<template>
  <div class="container">
    <template
      v-if="insuType === 'travel'"
    >
      <div class="shadow-wrapper decoration-top padding-m clearfix mb-s">
        <div class="insu-info">
          <h3 class="mb-s">旅遊資料</h3>
          <div class="flex-sc">
            <div class="label">旅遊地區：</div>
            <span
              v-text="travelAreas"
            />
          </div>
          <div class="flex-sc">
            <div class="label">投保期間：</div>
            <span
              v-text="insuPeriod"
            />
          </div>
        </div>
      </div>
    </template>
    <template
      v-if="insuType === 'accident'"
    >
      <div class="shadow-wrapper decoration-top padding-m clearfix mb-s">
        <div class="insu-info">
          <h3 class="mb-s">職業資料</h3>
          <div class="flex-sc">
            <div class="label">職業內容：</div>
            <span
              v-text="accidentAreas"
            />
          </div>          
          <div class="flex-sc">
            <div class="label">投保期間：</div>
            <span
              v-text="AccidentinsuPeriod"
            />
          </div>          
        </div>
      </div>
    </template>
    <template
      v-if="insuType === 'pet'"
    >
      <div class="shadow-wrapper decoration-top padding-m clearfix mb-s">
        <div class="insu-info">
          <h3 class="mb-s">寵物資料</h3>                  
          <div class="flex-sc">
            <div class="label">投保期間：</div>
            <span
              v-text="PetFilter.PetinsuPeriod"
            />
          </div>  
          <div class="flex-sc">
            <div class="label">寵物類型：</div>
            <span
              v-text="PetFilter.typeOfPet"
            />
          </div>    
          <div class="flex-sc">
            <div class="label">寵物姓名：</div>
            <span
              v-text="PetFilter.petName"
            />
          </div>
          <div class="flex-sc">
            <div class="label">寵物生日：</div>
            <span
              v-text="PetFilter.dateOfBirthPet"
            />
          </div>  
          <div class="flex-sc">
            <div class="label">性別：</div>
            <span
              v-text="PetFilter.petGender"
            />
          </div> 
          <div class="flex-sc">
            <div class="label">晶片號碼：</div>
            <span
              v-text="PetFilter.petNo"
            />
          </div>
          <div class="flex-sc">
            <div class="label">品種：</div>
            <span
              v-text="PetFilter.petBreed"
            />
          </div>
          <div class="flex-sc">
            <div class="label">毛色：</div>
            <span
              v-text="PetFilter.petColor"
            />
          </div>
          <div class="flex-sc">
            <div class="label">體重：</div>
            <span
              v-text="PetFilter.petWeight"
            />公斤(KG)
          </div>
          
          <div class="flex-sc">
            <div class="label">特徵說明：</div>
            <span
              v-text="PetFilter.petDesc"
            />
          </div>
          
        </div>
      </div>
    </template>
<template
      v-if="insuType === 'vaccine'"
    >
      <div class="shadow-wrapper decoration-top padding-m clearfix mb-s">
        <div class="insu-info">
          <h3 class="mb-s">疫苗險防疫險資料</h3>               
          <div class="flex-sc">
            <div class="label">投保期間：</div>
            <span
              v-text="VaccineinsuPeriod"
            />
          </div>          
        </div>
      </div>
    </template>

    <div class="shadow-wrapper padding-m clearfix mb-s">
      <div class="insu-quotes">
        <h3 class="mb-s">保費試算</h3>
         <p 
        class="tips-primary text-right mb-s"
        :style="{width: '100%'}"
      >保費合計： {{ premiums }}元</p>
        <Table
          class="mb-s table-wrapper"
          :columns="columns"
          :data="details"
        />
      </div>     
      <div class="prod-policies">
        <h3 class="mb-s">商品條款 
          <span 
            class="tips-primary fz-small"
          >（請閱覽並確認）</span>
        </h3>
        <div class="policies-list flex-sc dir-col">
          <span
            class="mb-xs fz-tiny"
          >
            我已閱覽下述約定事項
          </span>

          <div
            v-for="(item,index) in prodPolicies"
            class="flex-bc"
          >
            <Checkbox
              class="checkBox-pdf"
              v-model="confirmPolicies[index]"
              size="large"
              @on-change="val => checkAfterRead(val, index, item.title)"
            >
              <span 
                class="tips-primary pdf-link" 
                @click="policies.choosed = item;policies.modalStatus = true;item.isAgree = true "
                v-text="item.title"
              />      
            </Checkbox>
            
          </div>
        </div>
      </div>
    </div>
    <div class="text-right">
      <Button
        class="btn-m"
        :style="{marginRight: '10px'}"
        @click="back"
        v-text="'上一步'"
      />
      <Button
        class="btn-m btn-primary"
        :disabled="!agreeAll"
        @click="next"
        v-text="'下一步'"
      />
    </div>
    <PoliciesModal 
      v-model="policies.modalStatus"
      :data="choosedPolicie"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { Table, Button,Checkbox } from 'iview';
  import { log } from '@/utils/axios';
  import PoliciesModal from '@/components/modals/PoliciesModal';
  export default {
    components: { Table, Button,Checkbox, PoliciesModal },
    props: {
      insuType: {
        type: String,
        default: 'car'
      }      
    },
    data () {
      return {
        confirmPolicies: [],
        policies: {
          modalStatus: false,
          choosed: null
        }
      }
    },
    computed: {
      columns() {
        const cols = [
          { title: '承保範圍', key: 'title' },
          { title: '保額', key: 'desc', },
          { title: '保費', key: 'amount', maxWidth: 120 }
        ];
        if (this.insuType === 'travel'||this.insuType === 'accident'  || this.insuType === 'pet'|| this.insuType === 'vaccine') {
          return cols.filter(col => col.key !== 'amount')
        }
        return cols;
      },
      ...mapState({
        quotes: ({ checkout }) => checkout.quotes,
        travelInsuInfo: ({ checkout }) => checkout.travelInsuInfo,
        accidentInsuInfo: ({ checkout }) => checkout.accidentInsuInfo,
        petInsuInfo: ({ checkout }) => checkout.petInsuInfo,
        vaccintInfo:({checkout}) => checkout.vaccineInsuInfo,
        //checkout : ({ checkout }) => checkout,
        infoOfPet: ({checkout }) =>checkout.infoOfPet,
      }),
      prodPolicies() {
        let data = [...this.quotes.prodPolicies];
        this.confirmPolicies = data.map(element => {
          return element.isAgree = false;
        });
        return data;
      },
      choosedPolicie() {
        if(this.policies.choosed) {
          return this.policies.choosed;
        }else {
          return {};
        }
      },
      agreeAll() {
        return this.confirmPolicies.every((item) => {
          return item === true;
        })
      },
      details() {
        return this.quotes.details;
      },
      premiums() {
        return this.quotes.total;
      },
      quotationNum() {
        return this.quotes.quotationNum;
      },
      travelAreas() {
        const { travelArea } = this.travelInsuInfo;
        return travelArea.join('、');
      },
      insuPeriod() {
        const { insuPeriod } = this.travelInsuInfo;
        return insuPeriod;
      },
      accidentAreas() {
        const { accidentArea } = this.accidentInsuInfo;
        return accidentArea;
      },
      accidentBuy() {
        //console.log("this:"+JSON.stringify( this,censor(this)));
        //const { isbuy } = this.isbuy;
        //console.log("isbuy:"+isbuy);
        //return isbuy;
      },
      AccidentinsuPeriod() {
        const { AccidentinsuPeriod } = this.accidentInsuInfo;
        //console.log("AccidentinsuPeriod:"+AccidentinsuPeriod);
        return AccidentinsuPeriod;
      },
      VaccineinsuPeriod() {
        const { VaccineinsuPeriod } = this.vaccintInfo;
        //console.log("VaccineinsuPeriod:"+VaccineinsuPeriod);
        return VaccineinsuPeriod;
      },      
     /* PetinsuPeriod() {
        console.log("this.InsuInfo+infoOfPet++"+JSON.stringify(this.infoOfPet));
        //console.log("this.petInsuInfo+++"+JSON.stringify(this.petInsuInfo));
        const { PetinsuPeriod } = this.petInsuInfo;
        //console.log("PetinsuPeriod:"+PetinsuPeriod);
        return PetinsuPeriod;

      },*/
      PetFilter()
      {
        const { petFilter } = this.infoOfPet;   
        const { PetinsuPeriod } = this.petInsuInfo;
        let typeofpet = petFilter.typeOfPet=='DOG'?'犬':'貓';
        let petgender = petFilter.petGender=='M'?'公':'母';
        let dateofbirthpet=Object.values(petFilter.dateOfBirthPet).join(' / ');
        let data ={typeOfPet:typeofpet,
                   petName:petFilter.petName,
                  petGender:petgender,
                  dateOfBirthPet: dateofbirthpet,
                  petNo:petFilter.petNo,
                  petBreed:petFilter.petBreed,
                  petColor:petFilter.petColor ,
                  petWeight:petFilter.petWeight ,
                  petDesc:petFilter.petDesc,
                  PetinsuPeriod: PetinsuPeriod};                         
        return data;
      },
      InsuCompanyUrl() {
        return this.quotes.InsuCompanyUrl;
      }

    },
    methods: {
      next() {
        this.$router.push({ 
          name: 'checkoutConfirm',
          params: { 
            current: 1,
          }
        });
      },
      back() {
        this.$router.push({ 
          name: 'checkoutInfo',
          params: { 
            current: 0,
          }
        });
      },
      checkAfterRead(val, index, title) {
        const basketId = this.quotes.basketNum;
        const webUserIP = this.$store.state.user.ip;
        const logPayload = { 
          basketId,
          webUserIP,
          webProgramCodeId: 'CKC',
          webControlCodeId: 'POL',
          webControlBefore: title
        };
        if(this.prodPolicies[index].isAgree !== this.confirmPolicies[index]) {
          this.confirmPolicies[index] = true;
        }
        if (val) {
          log(logPayload);
          // window.open(this.prodPolicies[index].url);
          this.confirmPolicies[index] = true;  
        }
      }
    }
  }
</script>

